<template>
  <div class="rhg-instructions-map__marker">
    <img v-if="marker.brand" class="rhg-instructions-map__marker__image" :width="width" :height="height" :src="`${iconsUrl}/${marker.brand}.svg`" :alt="`${marker.brand} logo`"/>
  </div>

</template>

<script>
import { assetsUrl } from '@/infrastructure/Configuration'

export default {
  name: 'CustomMarker',
  data: () => ({
    iconsUrl: `${assetsUrl}/img/logo/brands/rhg-rounded-map-brand-logo`,
    width: 48,
    height: 48
  }),
  props: {
    marker: Object
  }
}
</script>

<style lang="scss" scoped>

</style>
